import type { RangeBounds, StepperValueLabelMapping } from '../search-panel-types';
import useLocale from './useLocale';

const useRangeLabel = () => {
  const { t } = useLocale();

  const formatRangeLabel = (
    fieldKey: string,
    filter: RangeBounds,
    valueLabelMappings: StepperValueLabelMapping[] = [],
    isOpenEnded = false,
  ) => {
    const valueToLabel = new Map(valueLabelMappings.map((mapping) => [mapping.value, mapping.label]));
    const getLabel = (value: number): number | string => valueToLabel.get(value) ?? value;

    const isDuration = fieldKey === 'duration';
    const scale = (val: number) => (isDuration ? Math.round(val / 60) : val);

    if (fieldKey === 'properties.readabilityMetrics.iltLevel') {
      return `${t('filter.level')} ${filter.min}-${filter.max}`;
    } else if (fieldKey === 'properties.decodabilityLevel') {
      const formattedMin = getLabel(filter.min);
      const formattedMax = getLabel(filter.max);
      return `${t('filter.decodability_level')} ${formattedMin}-${formattedMax}`;
    } else {
      const range = isOpenEnded ? `${scale(filter.min)}+` : `${scale(filter.min)}-${scale(filter.max)}`;
      return `${range} ${t(`filter.${fieldKey}`)}`;
    }
  };

  return { formatRangeLabel };
};

export default useRangeLabel;
